export var mobileCalendarTypesEnum = {
  scrollable: 'scrollable',
  none: 'none'
};
export var mobileCalendarTypes = Object.values(mobileCalendarTypesEnum);
export var locales = ['en', 'ru', 'it', 'es', 'de', 'zh', 'el'];
export var sizes = ['small'];
export var themes = ['b2c', 'b2b'];